module.exports = __webpack_public_path__ + "88517a4c979b3b197785e6dd3dce93be-pipelines_leak_response_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ugiPipelines/assets/pipelines_leak_response_2x.png
// module id = 761
// module chunks = 0